module.exports = {"110228001":"鼓楼街道","110228002":"果园街道","110228003":"檀营地区","110228100":"密云镇","110228101":"溪翁庄镇","110228102":"西田各庄镇","110228103":"十里堡镇","110228104":"河南寨镇","110228105":"巨各庄镇","110228106":"穆家峪镇","110228107":"太师屯镇","110228108":"高岭镇","110228109":"不老屯镇","110228110":"冯家峪镇","110228111":"古北口镇","110228112":"大城子镇","110228113":"东邵渠镇","110228114":"北庄镇","110228115":"新城子镇","110228116":"石城镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110228.json
// module id = 38
// module chunks = 0